import { Outlet } from 'react-router';

import { DelegationBar } from '@/component';
import { ToolPlayControllerContextProvider } from '@/component/Tool/ToolPlayController';
import { VFlex, VStack } from '@/package';
import {
  FrameImageViewerProvider,
  LabelingBoxContextProvider,
} from '@/provider';
import { useCollectionManagementStore, useTenantStore } from '@/store';

import { TaskLayoutFooter } from './TaskLayoutFooter';
import { TaskLayoutHeader } from './TaskLayoutHeader';
import { TaskLayoutToolbar } from './TaskLayoutToolbar';

const TaskLayout = () => {
  const { currentTenantID, isDelegationMode } = useTenantStore();
  const { isConnected } = useCollectionManagementStore();
  const isReady = currentTenantID ? isConnected() : false;

  return (
    <LabelingBoxContextProvider>
      <FrameImageViewerProvider>
        <ToolPlayControllerContextProvider>
          <VStack className="relative h-screen w-screen">
            {isDelegationMode() && <DelegationBar />}
            <TaskLayoutHeader />

            <VFlex className="flex-1 overflow-hidden">
              <TaskLayoutToolbar />
              <div className="h-full flex-1 overflow-hidden bg-black/10">
                {isReady ? <Outlet /> : <></>}
              </div>
            </VFlex>

            <TaskLayoutFooter />
          </VStack>
        </ToolPlayControllerContextProvider>
      </FrameImageViewerProvider>
    </LabelingBoxContextProvider>
  );
};

export default TaskLayout;
